/* Store module to handle todo-menu */
import Vue from 'vue';
import EventBus from '@/core/event-bus.js';

const state = {
  invoiceAddresses: [],
  invoiceAddress: {},
  combinedTodos: [],
  combinedTodo: {},
  costTodos: [],
  costTodo: {},
  fundingTodos: [],
  fundingTodo: {},
};

const mutations = {
  invoiceAddresses(state, payload) {
    state.invoiceAddresses = payload;
  },
  invoiceAddress(state, payload) {
    state.invoiceAddress = payload;
  },
  combinedTodos(state, payload) {
    state.combinedTodos = payload;
  },
  combinedTodo(state, payload) {
    state.combinedTodo = payload;
  },
  costTodos(state, payload) {
    state.costTodos = payload;
  },
  costTodo(state, payload) {
    state.costTodo = payload;
  },
  fundingTodos(state, payload) {
    state.fundingTodos = payload;
  },
  fundingTodo(state, payload) {
    state.fundingTodo = payload;
  },
  patchCombinedTodo(state, payload) {
    const index = state.combinedTodos.findIndex(
      c => c.externalId === payload.externalId
    );
    if (index !== -1) {
      Vue.set(
        state.combinedTodos,
        index,
        Object.assign({}, state.combinedTodos[index], payload)
      );
    }
    state.combinedTodo = Object.assign({}, state.combinedTodo, payload);
  },
  patchCostTodo(state, payload) {
    const index = state.costTodos.findIndex(
      c => c.externalId === payload.externalId
    );
    if (index !== -1) {
      Vue.set(
        state.costTodos,
        index,
        Object.assign({}, state.costTodos[index], payload)
      );
    }
    state.costTodo = Object.assign({}, state.costTodo, payload);
  },
  patchFundingTodo(state, payload) {
    const index = state.fundingTodos.findIndex(
      c => c.externalId === payload.externalId
    );
    if (index !== -1) {
      Vue.set(
        state.fundingTodos,
        index,
        Object.assign({}, state.fundingTodos[index], payload)
      );
    }
    state.fundingTodo = Object.assign({}, state.fundingTodo, payload);
  },
  patchInvoiceAddress(state, payload) {
    const index = state.invoiceAddresses.findIndex(c => c.id === payload.id);
    if (index !== -1) {
      Vue.set(
        state.invoiceAddresses,
        index,
        Object.assign({}, state.invoiceAddresses[index], payload)
      );
    }
    state.invoiceAddress = Object.assign({}, state.invoiceAddress, payload);
  },
};

const getters = {
  invoiceAddresses: state => {
    return state.invoiceAddresses;
  },
  invoiceAddress: state => {
    return state.invoiceAddress;
  },
  combinedTodos: state => {
    return state.combinedTodos;
  },
  combinedTodo: state => {
    return state.combinedTodo;
  },
  costTodos: state => {
    return state.costTodos;
  },
  costTodo: state => {
    return state.costTodo;
  },
  fundingTodos: state => {
    return state.fundingTodos;
  },
  fundingTodo: state => {
    return state.fundingTodo;
  },
};

const actions = {
  getInvoiceAddresses: async (context, params) => {
    await fetch(context, 'todo/invoiceAddresses', 'invoiceAddresses');
  },
  getInvoiceAddress: async (context, params) => {
    fetch(context, 'todo/invoiceAddresses/' + params.id, 'invoiceAddress');
  },
  patchInvoiceAddress: async (context, params) => {
    await patch(
      context,
      'todo/invoiceAddresses/' + params.id,
      params,
      'patchInvoiceAddress'
    );
  },
  getCombinedTodos: async (context, params) => {
    await fetch(context, 'todo/combinedTodos', 'combinedTodos');
  },
  getCombinedTodo: async (context, params) => {
    await fetch(context, 'todo/combinedTodos/' + params.id, 'combinedTodo');
  },
  patchCombinedTodo: async (context, params) => {
    await patch(
      context,
      'todo/combinedTodos/' + params.id,
      params,
      'patchCombinedTodo'
    );
  },
  getCostTodos: async (context, params) => {
    await fetch(context, 'todo/costTodos', 'costTodos');
  },
  getCostTodo: async (context, params) => {
    await fetch(context, 'todo/costTodos/' + params.id, 'costTodo');
  },
  patchCostTodo: async (context, params) => {
    await patch(
      context,
      'todo/costTodos/' + params.id,
      params,
      'patchCostTodo'
    );
  },
  getFundingTodos: async (context, params) => {
    await fetch(context, 'todo/fundingTodos', 'fundingTodos');
  },
  getFundingTodo: async (context, params) => {
    await fetch(context, 'todo/fundingTodos/' + params.id, 'fundingTodo');
  },
  patchFundingTodo: async (context, params) => {
    await patch(
      context,
      'todo/fundingTodos/' + params.id,
      params,
      'patchFundingTodo'
    );
  },
};

async function fetch(context, path, commit) {
  let response = {};
  try {
    response = await Vue.axios.get(path);
  } catch (error) {
    EventBus.$emit('toast', {
      type: 'error',
      msg: error.response.data.message,
      request: path,
    });
  }
  if (response && response.status === 200) {
    const data = response.data;
    context.commit(commit, data.result);
  }
}

async function patch(context, path, body, commit) {
  let response = {};
  try {
    response = await Vue.axios.patch(path, body);
    if (response && response.status === 200) {
      const data = response.data;
      context.commit(commit, data.result);
    }
  } catch (error) {
    EventBus.$emit('toast', {
      type: 'error',
      msg: error.response.data.message,
      request: path,
    });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
